import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const FooterContainer = styled.footer`
  background-color: #222;
  color: #fff;
  padding: 3rem 0;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 0 2rem;
`;

const FooterSection = styled.div`
  h3 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    color: #0099cc;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  li {
    color: #ccc;
    transition: color 0.3s ease;

    &:hover {
      color: #fff;
    }
  }
`;

const Copyright = styled.div`
  text-align: center;
  color: #ccc;
  font-size: 0.9rem;
`;

const Footer = () => {
  return (
    <FooterContainer>
      {/* <FooterContent>
        <FooterSection>
          <h3>会社情報</h3>
          <ul>
            <li>
              <Link to="/company">会社概要</Link>
            </li>
            <li>
              <Link to="/recruitment">採用情報</Link>
            </li>
            <li>
              <Link to="/news">ニュース</Link>
            </li>
          </ul>
        </FooterSection>

        <FooterSection>
          <h3>事業内容</h3>
          <ul>
            <li>
              <Link to="/products">SES</Link>
            </li>
            <li>
              <Link to="/products">受託開発</Link>
            </li>
            <li>
              <Link to="/products">IT教育</Link>
            </li>
            <li>
              <Link to="/products">農業</Link>
            </li>
          </ul>
        </FooterSection>

        <FooterSection>
          <h3>お問い合わせ</h3>
          <ul>
            <li>
              <Link to="/contact">お問い合わせフォーム</Link>
            </li>
            <li>メール: info@technoroaig.com</li>
          </ul>
        </FooterSection>
      </FooterContent> */}
      <Copyright>
        &copy; {new Date().getFullYear()} テクノロイグ株式会社 All Rights
        Reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
